<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" type="select" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="退款单号" name="refund_number"></c-form-item>
          <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="会员手机号" name="user_manage_mobilephone"></c-form-item>
          <c-form-item type="input" label="纠纷退款单号" name="dispute_refund_number"></c-form-item>
          <c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="checkbox" label="退款单状态" name="state" :options="disputeState"></c-form-item>
				</c-form>
			</m-search>
			<c-table ref="table" >
        <c-table-column
					label="状态"
					name="state"
					width="85"
				>
					<template v-slot="{data}">
						<span style="color:#182eff" v-if="data.state==1">{{disputeStateName[data.state]}}</span>
						<span style="color:darkgreen" v-if="data.state==2">{{disputeStateName[data.state]}}</span>
						<span style="color:gray" v-if="data.state==3">{{disputeStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="退款单号"
					name="refund_number"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="商家名称"
					name="stationed_name"
					width="110"
				></c-table-column>

        <c-table-column
                label="会员头像/昵称"
                name="head_photo"
                width="120"
        >
            <template v-slot="{data}">
                <div class="flex-center-cross">
                    <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                    <span>{{data.nick_name||'--'}}</span>
                </div>
            </template>
        </c-table-column>

        <c-table-column
            label="会员手机号"
            name="user_manage_mobilephone"
            width="120"
        ></c-table-column>

        <c-table-column
            label="诉求"
            width="150"
        >
          <template v-slot="{data}">
            <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" :title="data.claim" >
              {{data.claim}}
            </div>
          </template>
        </c-table-column>

				<c-table-column
					label="申请时间"
					name="create_date"
				    width="140"
				></c-table-column>

        <c-table-column
            label="用户撤销时间"
            name="cancel_date"
            width="140"
        ></c-table-column>

        <c-table-column
            label="处理时间"
            name="plat_process_date"
            width="140"
        ></c-table-column>

        <c-table-column
            label="处理信息"
            width="150"
        >
          <template v-slot="{data}">
            <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" :title="data.plat_process_notes" >
              {{data.plat_process_notes}}
            </div>
          </template>
        </c-table-column>

        <c-table-column
            label="纠纷退款单号"
            name="plat_process_refund_number"
            width="120"
        ></c-table-column>
        <c-table-column
            label="纠纷退款金额"
            name="refund_total_money"
        >
          <template v-slot="{data}">
            <span style="color:blue" v-if="data.refund_total_money&&data.refund_total_money>0">￥{{data.refund_total_money.toFixed(2)}}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>
        <c-table-column
            label="处理人"
            name="plat_process_user"
            width="90"
        ></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
          width="80"
        >
					<template v-slot="{data}">
						<c-table-button @click="navigateTo({path: `/dispute_detail/${data.id}`, query: {}})">查看</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	export default {
		name: 'm_dispute',

		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector
		},
		
    props: {
        state: String,
        refund_state: String,

    },

		data() {
        return {
          searchParams:{},
          disputeState: [{
              name: '待处理',
              value: 1
            },{
              name: '处理完成',
              value: 2
            },{
              name: '用户撤销',
              value: 3
            }
          ],
          disputeStateName: {
            1: '待处理',
            2: '处理完成',
            3: '用户撤销'
          }
        }
      },

        computed: {
            ...mapState(['systemConfig', 'userInfo']),
            defaultSearch() {
                let param = {
                    state: this.state ? this.state.split(',') : [],
                }
                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },
		
		mounted() {
        this.$refs.searchForm.set(this.defaultSearch);
        this.$nextTick(() => {
            this.$refs.search.search();
        })
        this.$bus.$on('disputeList.update', data => {
          // 刷新列表
          this.$refs.table.update();
        });
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/dispute/list',
					data
				});
        this.searchParams = data||{};
      },
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},
		}
	}
</script>